import React from 'react'

import useStyles from '../styles'
import { MultilineInput } from '_/components/inputs'
import { strMaxLenMessage } from '_/utils/form-validations'
import { useFormContext } from 'react-hook-form'
import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'

const NAME = 'problemDescription'

export function DiagnosisField() {
  const { watch } = useFormContext()
  const styles = useStyles()
  const { addProblemReadOnly } = useBudgetForm()

  return (
    <MultilineInput
      required
      defaultValue={watch(NAME)}
      placeholder="Qual o problema? O que aconteceu?"
      name={NAME}
      labelClasses={styles.label}
      label="Diagnóstico do problema"
      rules={{ maxLength: { value: 5000, message: strMaxLenMessage(5000) } }}
      maxRows={100}
      disabled={addProblemReadOnly}
    />
  )
}
